export type DropdownOpenDirection = 'down' | 'up'

const DROPDOWN_OPTIONS_BASE_CLASS = 'dropdown-options nav flex-column'

export const getDropdownOptionsClassName = (
  openDirection: DropdownOpenDirection = 'down',
): string => {
  if (openDirection === 'up') {
    return `${DROPDOWN_OPTIONS_BASE_CLASS} dropdown-options--up`
  }
  return DROPDOWN_OPTIONS_BASE_CLASS
}
